/**
 * Article  Functional Component
 * @Package - seo/brandPart
 * @Author - Cybage@UPWA-Team
 * @description: Articles related to brandPart SEO
 */
/**
 *  BrandPart SEO's Article Component
 */
import React, { useMemo } from 'react'
import SeoArticle from '../../SeoArticle'

export default function Article({ dynamicApiData }) {
  const articles = useMemo(
    () => (dynamicApiData && dynamicApiData.articles) || {},
    [dynamicApiData],
  )
  const dataArticle = useMemo(() => (articles && articles.data) || [], [
    articles,
  ])
  const attributes = useMemo(
    () => (dynamicApiData && dynamicApiData.attributes) || {},
    [dynamicApiData],
  )
  const hasDataArticles = useMemo(
    () => Boolean(
      dataArticle
           && Array.isArray(dataArticle)
           && Boolean(dataArticle && dataArticle.length)
           && dataArticle.find(article => article.text.replace(/\s+/g, '').length),
    ),
    [dataArticle],
  )
  const headings = useMemo(() => dynamicApiData && dynamicApiData.headings, [
    dynamicApiData,
  ])
  const articlesHeadings = headings && headings.articles ? headings.articles : ''
  const pageType = dynamicApiData && dynamicApiData.pageType ? dynamicApiData.pageType : ''
  const article = useMemo(() => (hasDataArticles ? dataArticle : []), [
    dataArticle,
    hasDataArticles,
  ])

  return (
    <SeoArticle
      id="BrandPartArticle"
      data={article}
      title={articlesHeadings}
      pageType={pageType}
      attributes={attributes}
    />
  )
}
